interface Props {
  grade: 'A' | 'B' | 'C' | 'D' | 'F' | null;
  budgetConsumed: number | null;
}

const TONE: Record<string, string> = {
  A: 'bg-status-up/10 text-status-up',
  B: 'bg-status-up/10 text-status-up',
  C: 'bg-status-degraded/10 text-status-degraded',
  D: 'bg-status-degraded/10 text-status-degraded',
  F: 'bg-status-down/10 text-status-down',
};

export function GradeBadge({ grade, budgetConsumed }: Props) {
  if (grade === null) {
    return <span className="text-gray-400" title="No data in this period">—</span>;
  }
  return (
    <span
      className={`inline-flex items-center justify-center w-7 h-7 rounded-md font-bold text-sm ${TONE[grade]}`}
      title={budgetConsumed === null ? undefined : `${budgetConsumed}% of error budget consumed`}
    >
      {grade}
    </span>
  );
}
